import { useState } from 'react';
import { Badge, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { logoutf } from '../../../store/usertoken/usertokenSlice'
import { Trans } from 'react-i18next';
import UserTokenDialog from './UserTokenDialog';

const UserMenu = (): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const userTokenStatus = useAppSelector(state => state.usertoken)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const logout = () => {
   // setAnchorEl(null);
    dispatch(logoutf());
    window.location.reload();
  };

  return (
    <div>
      <Badge 
        invisible={userTokenStatus.authenticated} 
        badgeContent={'!'} 
        color={'error'}
        overlap={"circular"}>
        <IconButton
          size="large"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenuClick}
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          {userTokenStatus.authenticated ? (
            <MenuItem onClick={logout} >
              <Trans>Logout</Trans>
            </MenuItem>
          ) : (<></>)}
          <MenuItem onClick={()=>{setOpen(true)}}>
            {userTokenStatus.authenticated ? (
              <Typography><Trans>Logged in as: </Trans><i>{userTokenStatus.token}</i></Typography>
            ) : (
              <Typography><Trans>Login</Trans></Typography>
            )}
          </MenuItem>
          <UserTokenDialog open={open} onClose={() => {setOpen(false)}}/>
        </Menu>
      </Badge>
    </div>
  );
};

export default UserMenu;
